import { validateApiKey } from "@shared/validation/admin";

/** Explicit safe metadata projection. Tokens/hashes never enter validation. */
export function apiKeyMetadata(record: Record<string, unknown>) {
  return { id: record.id, name: record.name, defaultVenueId: record.defaultVenueId, defaultSourceId: record.defaultSourceId, scopes: record.scopes };
}

/** Loaded authorized references are advisory facts, never server completeness. */
export function apiKeyMetadataFindings(record: Record<string, unknown>, venues?: readonly { id: string }[], sources?: readonly { id: string }[]) {
  const metadata = apiKeyMetadata(record);
  return validateApiKey(metadata, { checksComplete: false, references: {
    ...(venues ? { defaultVenueId: !metadata.defaultVenueId || venues.some(row => row.id === metadata.defaultVenueId) } : {}),
    ...(sources ? { defaultSourceId: !metadata.defaultSourceId || sources.some(row => row.id === metadata.defaultSourceId) } : {}),
  } });
}
